import { IDataManager } from './idata_manager';
import { IPhotoDataManager,IGatewayDataManager, IGatewayAlbumDataManager } from '../photo/iphoto_data_manager';
import { UAPhotoManager } from '../photo/ua_photo_data_manager';
import { IAlbumDataManager } from '../album/ialbum_data_manager';
import { UAAlbumManager } from '../album/ua_album_manager';
import { IClientConfig } from './data_manager_factory';
import { UAShareManager } from '../share/ua_share_manager';
import { IShareDataManager } from '../share/ishare_data_manager';
import { IAccountsDataManager } from '../accounts/iaccounts_data_managter';
import { UAAccountsManager } from '../accounts/ua_accounts_manager';
import { GatewayPhotoDataManager } from '../photo/gateway_photo_data_manager';
import { GatewayAlbumDataManager } from '../album/gateway_album_data_manager';


/**
 * Responsible to create and return appropriate view specific manager objects, in User-Assets(non-aggregated) flow
 * @export
 * @class UADataManager
 * @implements {IDataManager}
 */
export class UADataManager implements IDataManager {
     private _photoManager: IPhotoDataManager;
     private _albumManager: IAlbumDataManager;
     private _shareManager: IShareDataManager;
     private gateWayPhotoManager: IGatewayDataManager;
     private gateWayAlbumManager:  IGatewayAlbumDataManager;
     private accountsManager: IAccountsDataManager;

     constructor(config: IClientConfig) {
         this._photoManager = new  UAPhotoManager(config);
         this._albumManager = new UAAlbumManager(config);
         this._shareManager = new UAShareManager(config);
         this.accountsManager= new UAAccountsManager(config);
         this.gateWayPhotoManager = new GatewayPhotoDataManager(config);
         this.gateWayAlbumManager = new GatewayAlbumDataManager(config);
     }
    getPhotoManager(): IPhotoDataManager {
        return this._photoManager;
    }
    getAlbumManager(): IAlbumDataManager {
        return this._albumManager;
    }
    getShareManager(): IShareDataManager {
        return this._shareManager;
    }

    getAccountsManager(): IAccountsDataManager{
        return this.accountsManager;
    }

    getGatewayPhotoManager(): IGatewayDataManager{
        return this.gateWayPhotoManager;
    }

    getGatewayAlbumManager(): IGatewayAlbumDataManager{
        return this.gateWayAlbumManager;
    }

}